const cards = [
  {
    image: 'https://readdy.ai/api/search-image?query=Abstract%20dramatic%20red%20carpet%20fragments%20collage%2C%20warm%20coral%20and%20amber%20lighting%2C%20mysterious%20atmosphere%2C%20editorial%20photography%20style%2C%20dark%20background&width=600&height=400&seq=card-01-2026&orientation=landscape',
    tag: '独家爆料',
    title: '某女团C位被曝与经纪人有不正当关系，聊天记录大量流出',
    source: '51吃瓜同步',
    time: '2小时前',
    views: '56.8万',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Abstract%20broken%20trophy%20and%20scattered%20documents%20collage%2C%20warm%20golden%20lighting%2C%20dramatic%20investigative%20style%2C%20editorial%20design&width=600&height=400&seq=card-02-2026&orientation=landscape',
    tag: '深度调查',
    title: '某选秀节目黑幕全曝光：票数造假、导师内定、制作费被贪',
    source: '17c黑料',
    time: '5小时前',
    views: '42.3万',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Abstract%20social%20media%20interface%20fragments%20collage%2C%20warm%20coral%20accents%2C%20modern%20digital%20atmosphere%2C%20editorial%20style%2C%20dark%20moody%20background&width=600&height=400&seq=card-03-2026&orientation=landscape',
    tag: '热搜追踪',
    title: '多位明星小号被扒：骂粉丝、吐槽同行、炫耀奢侈生活全记录',
    source: '编辑整理',
    time: '8小时前',
    views: '38.1万',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Abstract%20film%20set%20elements%20collage%2C%20warm%20amber%20and%20coral%20lighting%2C%20behind%20scenes%20drama%2C%20editorial%20photography%2C%20dark%20atmosphere&width=600&height=400&seq=card-04-2026&orientation=landscape',
    tag: '剧组揭秘',
    title: '某大制作剧组霸王条款曝光：群演日薪不足百元且无保险',
    source: '51吃瓜同步',
    time: '12小时前',
    views: '29.6万',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Abstract%20luxury%20brand%20fragments%20collage%2C%20warm%20golden%20highlights%2C%20commercial%20photography%20vibe%2C%20editorial%20magazine%20style%2C%20dark%20elegant%20background&width=600&height=400&seq=card-05-2026&orientation=landscape',
    tag: '品牌风波',
    title: '某国际大牌中国区代言人深陷丑闻，品牌方紧急解约索赔',
    source: '17c黑料',
    time: '16小时前',
    views: '25.4万',
  },
];

export default function SectionCards() {
  return (
    <section id="cards" className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1200px] mx-auto">
        <div className="flex items-center gap-3 mb-2">
          <div className="w-1 h-6 bg-accent-500 rounded-full"></div>
          <h2 className="text-xl md:text-2xl font-heading text-foreground-950">深度爆料</h2>
          <span className="text-xs bg-accent-100 text-accent-700 px-2 py-0.5 rounded-full font-semibold whitespace-nowrap">重磅</span>
        </div>
        <p className="text-sm text-foreground-600 mb-8 md:mb-10 pl-4">娱乐圈深度调查报道，独家明星黑料与八卦揭秘，吃瓜群众不可错过</p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cards.map((card, i) => (
            <a
              key={i}
              href="#"
              onClick={(e) => e.preventDefault()}
              className={`group block bg-background-100 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-colors cursor-pointer ${
                i === 0 ? 'lg:col-span-2' : ''
              }`}
            >
              <div className={`relative w-full overflow-hidden ${i === 0 ? 'aspect-[16/7]' : 'aspect-[16/10]'}`}>
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="bg-primary-500 text-white text-xs px-2.5 py-1 rounded-full font-semibold whitespace-nowrap">
                    {card.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2 mb-3">
                  {card.title}
                </h3>
                <div className="flex items-center justify-between text-xs text-foreground-500 flex-wrap gap-2">
                  <span className="bg-secondary-100 text-secondary-700 px-2 py-0.5 rounded whitespace-nowrap">
                    {card.source}
                  </span>
                  <div className="flex items-center gap-3">
                    <span>{card.time}</span>
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line"></i>
                      {card.views}
                    </span>
                  </div>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}